import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import useProfileData from '../services/ProfileDataService';
import { PageLayout } from './authentication/PageLayout';

export const NavMenu = () => {
  const { userName, profileImage, isAdmin} = useProfileData();
  const [show, setShow] = useState(false);
  const anchor = useRef<HTMLButtonElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const defaultProfileImage = "/defaultProfilePicture.png";

  const togglePopup = () => setShow(prev => !prev);

 useEffect(() => {
  
}, [isAdmin]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current && 
        anchor.current && 
        !dropdownRef.current.contains(event.target as Node) && 
        !anchor.current.contains(event.target as Node)
      ) {
        setShow(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header className="bg-white border-b border-gray-200">
      <div className="flex items-center justify-between px-4 py-2">
        <div className="flex items-center space-x-2">
          <a href='/'><img className="h-8" src="/logo.svg" alt="Daikin Logo" /></a>
          <a href='/'><span className="text-lg text-[#838689]">App Center</span></a>
        </div>

        <div className="flex items-center">
          <div className="relative">
            <button 
              className="flex items-center space-x-2 hover:bg-gray-100 rounded-md px-2 py-1 focus:outline-none"
              onClick={togglePopup}
              ref={anchor}
              aria-expanded={show}
              aria-haspopup="true"
            >
              <div className="hidden md:flex flex-col items-end mr-2">
                <span className="text-sm font-medium text-gray-700">{userName || 'User'}</span>
              </div>
              <img 
                className="w-8 h-8 rounded-full border border-gray-200"
                src={profileImage || defaultProfileImage}
                alt="User profile"
                onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                  (e.target as HTMLImageElement).src = defaultProfileImage;
                }}
              />
              <svg 
                className={`w-4 h-4 ml-1 text-gray-500 transition-transform duration-200 ${show ? 'rotate-180' : ''}`}
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M7 10l5 5 5-5z" />
              </svg>
            </button>

            {show && (
              <div 
                ref={dropdownRef}
                className="absolute right-0 mt-2 bg-white shadow-lg rounded-md w-48 py-1 z-10 border border-gray-200"
              >
                <div className="px-4 py-2 border-b border-gray-200">
                  <div className="flex items-center justify-between space-x-2">
                    <div>
                      <p className="text-sm font-medium text-gray-700">{userName || 'User'}</p>
                    </div>
                    <img 
                      className="w-10 h-10 rounded-full"
                      src={profileImage || defaultProfileImage}
                      alt="User profile"
                      onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                        (e.target as HTMLImageElement).src = defaultProfileImage;
                      }}
                    />
                  </div>
                </div>

                <div className="px-2 py-1 flex flex-col space-y-1">
                  {isAdmin && (
                    <Link 
                      to="/admin"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
                    >
                      Admin Panel
                    </Link>
                  )}
                  <PageLayout />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};